var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, PropertyConverters, Utils, ViewChild, Watch } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
const StringOrBooleanPropertyConverter = {
    convert: (attr) => attr === 'true' ? true : (attr === 'false' ? false : attr),
    convertBack: (prop) => prop.toString()
};
let PacemCheckboxElement = class PacemCheckboxElement extends PacemBaseElement {
    constructor() {
        super('checkbox');
        this.caption = '';
        this._key = '_' + Utils.uniqueCode();
    }
    convertValueAttributeToProperty(attr) {
        StringOrBooleanPropertyConverter.convert(attr) === this.trueValue ? this.trueValue : this.falseValue;
    }
    toggleReadonlyView(readonly) {
        this.span.hidden = !readonly;
        this._checkbox.hidden = this._label.hidden = readonly;
    }
    get inputFields() {
        return [this._checkbox];
    }
    onChange(evt) {
        this.selected = this._checkbox.checked;
        const value = this.value = this.selected ? this.trueValue : this.falseValue;
        return Utils.fromResult(value);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._checkbox.id = this._label.htmlFor = this._key;
        this._synchronizeUi();
        if (this.value /* weak equality to deal with declarative values and conversions */ == this.trueValue)
            this.selected = true;
        else if (this.value /* weak equality to deal with declarative values and conversions */ == this.falseValue)
            this.selected = false;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!this.isReady) {
            // the following are only UI-relevant modifications
            return;
        }
        switch (name) {
            case 'caption':
                this._label.hidden = Utils.isNullOrEmpty(val);
                break;
            case 'name':
                this._checkbox.name = val;
                break;
            case 'selected':
                this._synchronizeUi();
                break;
        }
    }
    _synchronizeUi(val = this.selected) {
        if (this._checkbox.checked = val) {
            this.value = this.trueValue;
            Utils.addClass(this, PCSS + '-selected');
            this.aria.attributes.set('checked', 'true');
        }
        else {
            this.value = this.falseValue;
            Utils.removeClass(this, PCSS + '-selected');
            this.aria.attributes.set('checked', 'false');
        }
    }
    acceptValue(val) {
        this.selected = val /* weak equality to deal with declarative values and conversions */ == this.trueValue;
    }
    getViewValue(val) {
        if (!Utils.isNull(val))
            return this.caption;
        return '';
    }
};
__decorate([
    ViewChild("input[type=checkbox]")
], PacemCheckboxElement.prototype, "_checkbox", void 0);
__decorate([
    ViewChild("label")
], PacemCheckboxElement.prototype, "_label", void 0);
__decorate([
    ViewChild(`.${PCSS}-readonly`)
], PacemCheckboxElement.prototype, "span", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemCheckboxElement.prototype, "caption", void 0);
__decorate([
    Watch({ emit: false, converter: StringOrBooleanPropertyConverter })
], PacemCheckboxElement.prototype, "trueValue", void 0);
__decorate([
    Watch({ emit: false, converter: StringOrBooleanPropertyConverter })
], PacemCheckboxElement.prototype, "falseValue", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemCheckboxElement.prototype, "selected", void 0);
PacemCheckboxElement = __decorate([
    CustomElement({
        tagName: P + '-checkbox',
        template: `<${P}-span class="${PCSS}-readonly ${PCSS}-checkbox" text="{{ :host.caption }}"></${P}-span>
<input type="checkbox" class="${PCSS}-input" /><label class="${PCSS}-label ${PCSS}-checkbox ${PCSS}-viewfinder" pacem><${P}-span content="{{ :host.caption }}"></${P}-span></label>`,
        shadow: Defaults.USE_SHADOW_ROOT
    })
], PacemCheckboxElement);
export { PacemCheckboxElement };
